/**
 * Remove any extra slashes or colons from a url
 */
export function normalizeUrl(url: string): string {
  return url.replace(/([^:])(\/\/+)/g, '$1/');
}
